import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  /**
   * GET `/summary/operation_mode/{start}/{end}` — porsi waktu per mode operasi.
   * Balikin response axios UTUH, jalur bacanya `res.data.data`.
   *
   * Ditolak izin dibalas HTTP 200 + `status.errorCode` 412 di body; pemanggil
   * ngosongin summary lalu berhenti (src/views/report/OperationModeSummary.vue:278).
   *
   * `res.data.data.total.mode` peta mode -> detik, `res.data.data.total.runningSeconds`
   * penyebut buat itung persen.
   *
   * @param {Object} options
   * @param {number} options.start unix detik
   * @param {number} options.end unix detik
   * @param {number|string} options.devcId id device RPM
   * @returns {Promise<import('axios').AxiosResponse<{data: Object, status: import('@/services/_AxiosInstance').ApiStatus}>>}
   *   response axios utuh — jalur bacanya `res.data.data`
   */
  getOperationModeSummary({ start, end, devcId }) {
    return axiosInstance.get(`/summary/operation_mode/${start}/${end}`, {
      params: {
        devcId,
      },
      cancelToken: getNewCancelToken(),
    });
  },

  /**
   * GET `/summary/operation_mode/series/{start}/{end}` — deret per menit.
   * Balikin response axios UTUH, jalur bacanya `res.data.data`.
   *
   * `status.errorCode` 400 di sini BUKAN error umum: artinya rentang per-menit
   * dibatasi 7 hari. Datangnya lewat HTTP 200. Summary tetep kepakai walau series
   * ditolak, jadi jangan gagalin seluruh halaman
   * (src/views/report/OperationModeSummary.vue:329).
   *
   * @param {Object} options
   * @param {number} options.start unix detik
   * @param {number} options.end unix detik
   * @param {number|string} options.devcId id device RPM
   * @returns {Promise<import('axios').AxiosResponse<{data: Object, status: import('@/services/_AxiosInstance').ApiStatus}>>}
   *   response axios utuh — jalur bacanya `res.data.data`
   */
  getOperationModeSeries({ start, end, devcId }) {
    return axiosInstance.get(`/summary/operation_mode/series/${start}/${end}`, {
      params: {
        devcId,
      },
      cancelToken: getNewCancelToken(),
    });
  },
};
